<template>
    <base-modal v-model="isVisible">
        <h2 class="text-center" v-html="$t('grantAccessClinicHistory')"></h2>
        <p v-html="$t('historyGrantAccessText')"></p>
        <div>
            <b-row>
                <b-col class="text-center px-2 my-2" sm="12" md="6">
                    <base-button @click="shareInternally">{{$t('shareInternally')}}</base-button>
                </b-col>
                <b-col class="text-center px-2 my-2" sm="12" md="6">
                    <base-button white @click="generateLink">{{$t('generateLink')}}</base-button>
                </b-col>
            </b-row>
        </div>
        <b-row class="mt-4" v-if="showInternalShareSelector">
            <b-col cols="12" md="6">
                <base-select @search="loadProfsAndCenters($event)" v-model="selectProfCenter.value" :loading="selectProfCenter.loading" :placeholder="$t('clinic-history.select-prof-center')" label="name" valueProp="id" searchable filtered :options="selectProfCenter.data" cl :disabled="id != null" />
                <base-button class="mt-4 grant-access-btn" @click="grantInternalAccessHistory">{{$t('historyShare')}}</base-button>
            </b-col>
        </b-row>
        <div class="mt-4" v-if="showGenerateLinkSelector">
            <div>
                <h3 v-html="$t('validityInDays')"></h3>
                <base-input v-model="shareLink.validity" type="number" :placeholder="$t('shareLinkValidity')" :min="1" :max="180" />
            </div>
            <div>
                <h3 v-html="$t('recipients')"></h3>
                <base-textarea v-model="shareLink.emails" :rows="5" :placeholder="$t('shareHistoryAccessLinkPlaceholder')" />
                <base-button class="mt-4 grant-access-btn" @click="sendLink">{{$t('send')}}</base-button>
            </div>
        </div>
    </base-modal>
</template>

<script>
import BaseModal from '@/components/base/BaseModal'
import ClinicHistoryRepository from '../../repositories/ClinicHistoryRepository'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    components: {
        BaseModal
    },
    props: {
        value: Boolean,
        id: String
    },
    mixins: [i18nMixin(I18N_FILE)],
    computed: {
        isVisible: {
            get () {
                return this.value
            },
            set (val) {
                this.$emit('input', val)
            }
        }
    },
    data () {
        return {
            showInternalShareSelector: false,
            showGenerateLinkSelector: false,
            userEmails: null,
            selectProfCenter: {
                value: null,
                loading: false,
                data: []
            },
            shareLink: {
               validity: null,
               emails: null
            }
        }
    },
    created () {
        if (this.id != null) {
            this.showInternalShareSelector = true
            ClinicHistoryRepository().getProfsAndCentersGrantAccessHistoryById(this.id).then(response => {
                if (response.data) {
                    this.selectProfCenter.data = [response.data]
                    this.selectProfCenter.value = response.data.id
                    this.cleanUrlFromQuery()
                }
            })
        }
    },
    methods: {
        cleanUrlFromQuery () {
            const cleanUrl = this.$router.resolve({ path: this.route }).href
            window.history.replaceState(null, '', cleanUrl)
        },
        shareInternally () {
            this.showInternalShareSelector = !this.showInternalShareSelector
            this.showGenerateLinkSelector = false
        },
        generateLink () {
            this.showGenerateLinkSelector = !this.showGenerateLinkSelector
            this.showInternalShareSelector = false
        },
        loadProfsAndCenters (name) {
            this.selectProfCenter.loading = true
            if (name && name.length >= 3) {
                ClinicHistoryRepository().getProfsAndCentersGrantAccessHistory(name).then(response => {
                    if (response.data) {
                        this.selectProfCenter.data = response.data
                    }
                    this.selectProfCenter.loading = false
                })
            } else {
                this.selectProfCenter.loading = false
            }
        },
        grantInternalAccessHistory () {
            if (!this.selectProfCenter.value) {
                this.$store.dispatch('showInfoAlert', this.$t('grantAccessSelectProfOrCenter'))
                return
            }
            let data = {userId: this.selectProfCenter.value}
            ClinicHistoryRepository().grantAccessHistory(data).then(response => {
                if (response.data.data) {
                    this.$store.dispatch('showSuccessAlert', this.$t('changesPerformedCorrectly'))
                    this.selectProfCenter.value = null
                    this.showInternalShareSelector = false
                }
            })
        },
        sendLink () {
            if (!this.shareLink.validity || this.shareLink.validity > 180 || this.shareLink.validity <= 0) {
                this.$store.dispatch('showInfoAlert', this.$t('sharelinkError.validity'))
            } else if (!this.shareLink.emails) {
                this.$store.dispatch('showInfoAlert', this.$t('sharelinkError.emails'))
            } else {
                let wrongEmails = this.shareLink.emails.split(/(,|;| |\n)+/).filter(m => this.$validators.validate(m, ['email']) === false && m !== ',' && m !== ';' && m !== ' ' && m !== '\n').filter((v, i, a) => a.indexOf(v) === i)
                if (wrongEmails.length > 0) {
                    this.$store.dispatch('showInfoAlert', `${this.$t('sharelinkError.wrongEmail')} ${wrongEmails}`)
                } else {
                    let emails = this.shareLink.emails.split(/(,|;| |\n)+/).filter(m => this.$validators.validate(m, ['email']) !== false).filter((v, i, a) => a.indexOf(v) === i)
                    ClinicHistoryRepository().shareHistoryLink({validity: this.shareLink.validity, emails: emails}).then(response => {
                        if (response.data.data) {
                            this.$store.dispatch('showSuccessAlert', this.$t('linkSendedSuccessfully'))
                            this.shareLink.validity = null
                            this.shareLink.emails = null
                            this.showGenerateLinkSelector = false
                        }
                    })
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.grant-access-btn{
    display: block;
    margin-left: auto;
    margin-right: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryGrantAccess.vue